import React, { createContext, useState, useEffect, useContext } from 'react';
import { auth, db } from '../firebase/config';
import { doc, getDoc, setDoc } from 'firebase/firestore';

// Crear un contexto para las preferencias del usuario
export const UserPreferencesContext = createContext();

export const UserPreferencesProvider = ({ children }) => {
  const [preferences, setPreferences] = useState({
    vistaTabla: null,
    filtroViajes: 'todos',
    loading: true
  });
  const [saving, setSaving] = useState(false);

  // Cargar preferencias al iniciar sesión
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const userPrefsRef = doc(db, 'levapan_userPreferences', user.uid);
          const userPrefsDoc = await getDoc(userPrefsRef);
          
          if (userPrefsDoc.exists()) {
            const prefs = userPrefsDoc.data();
            setPreferences({
              vistaTabla: prefs.vistaTabla !== undefined ? prefs.vistaTabla : window.innerWidth >= 768,
              filtroViajes: prefs.filtroViajes || 'todos',
              loading: false
            });
          } else {
            // Default values
            setPreferences({
              vistaTabla: window.innerWidth >= 768,
              filtroViajes: 'todos',
              loading: false
            });
          }
        } catch (err) {
          console.error("Error al cargar preferencias:", err);
          setPreferences({
            vistaTabla: window.innerWidth >= 768,
            filtroViajes: 'todos',
            loading: false
          });
        }
      } else {
        // No user logged in
        setPreferences({
          vistaTabla: window.innerWidth >= 768,
          filtroViajes: 'todos',
          loading: false
        });
      }
    });

    return () => unsubscribe();
  }, []);

  // Guardar preferencias
  const savePreference = async (key, value) => {
    if (!auth.currentUser) return;

    try {
      setSaving(true);
      // Update local state
      setPreferences(prev => ({
        ...prev,
        [key]: value
      }));

      // Update in Firestore
      const userPrefsRef = doc(db, 'levapan_userPreferences', auth.currentUser.uid);
      await setDoc(userPrefsRef, {
        [key]: value,
        lastUpdated: new Date()
      }, { merge: true });
    } catch (err) {
      console.error(`Error al guardar preferencia ${key}:`, err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <UserPreferencesContext.Provider 
      value={{
        preferences,
        saving,
        savePreference
      }}
    >
      {children}
    </UserPreferencesContext.Provider>
  );
};

// Hook personalizado para usar las preferencias del usuario
export const useUserPreferences = () => useContext(UserPreferencesContext);
